import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class FileUploadService {
  private apiUrl = `${environment.apiBaseUri}/api/files`;

  constructor(private http: HttpClient) { }

  upload(formData: FormData): Observable<any> {
    return this.http.post(`${this.apiUrl}/upload`, formData);
  }

  getFiles(imageKey: string): Observable<any[]> {
    return this.http.get<any[]>(`${this.apiUrl}?imageKey=${imageKey}`);
  }

  deleteFile(fileId: number): Observable<any> {
    return this.http.delete(`${this.apiUrl}/${fileId}`);
  }
}
